import type React from 'react';
import { useEffect } from 'react';
import { SnackbarProvider, type SnackbarProviderProps } from 'notistack';

import { Notification } from './Notification';

import './notistack.scss';

export interface NotificationsProviderProps {
  children: React.ReactNode;
}

const Components: SnackbarProviderProps['Components'] = {
  success: Notification,
  warning: Notification,
  error: Notification,
  info: Notification,
};

/** Defeat notistack Collapse inline pointerEvents:all + full-width wrappers.
 * Single runtime override (pairs with notistack.scss) - do not add more injectors. */
const NOTISTACK_POINTER_FIX = `
.notistack-SnackbarContainer{pointer-events:none!important;align-items:flex-end!important;width:auto!important;max-width:min(420px,calc(100% - 32px))!important}
.notistack-SnackbarContainer>div{pointer-events:none!important;width:auto!important;max-width:100%!important}
.notistack-CollapseWrapper,.notistack-CollapseWrapperTop,.notistack-CollapseWrapperBottom,.notistack-Snackbar{pointer-events:none!important;width:auto!important;max-width:100%!important}
`;

export const NotificationsProvider: React.FC<NotificationsProviderProps> = ({
  children,
}) => {
  useEffect(() => {
    const id = 'myteacher-notistack-pointer-fix';
    if (document.getElementById(id)) {
      return;
    }
    const style = document.createElement('style');
    style.id = id;
    style.textContent = NOTISTACK_POINTER_FIX;
    document.head.appendChild(style);
  }, []);

  return (
    <SnackbarProvider
      maxSnack={4}
      autoHideDuration={5000}
      Components={Components}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transitionDuration={{
        enter: 500,
        exit: 200,
      }}
      TransitionProps={{
        direction: 'left',
      }}
    >
      {children}
    </SnackbarProvider>
  );
};
